// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2aaa2aa4","453":"c7434320","455":"a5b2110e","977":"6ffc5774"}[chunkId] + ".chunk.js";
};